module.exports = __webpack_public_path__ + "media/images/of4-b6eff5a0d8b76d3ec390293e0f99b904.jpg";